<template>
	<div class="news-detail">

		<div class="page-back">
			<img src="@/assets/images/back.png" alt="back">
		</div>
		<div class="wp3" v-if="Object.keys(post).length > 0">
			<div class="title">
				<h2>{{post.title}}</h2>
				<h3>{{post.subtitle}}</h3>
				<div class="date">{{$dayjs(post.date).format('MMMM D, YYYY')}}</div>
			</div>
			<!-- <div class="media">
				<a :href="item.url + path" target="_blank" v-for="(item,index) in mediaList" :key="index"
					:title="item.txt">
					<img :src="item.img" :alt="item.txt">
				</a>
			</div> -->
			<div class="pic">
				<img
					:alt="`OCM Foods Group  - Asian food wholesale + ${post.title}, 亚洲食品批发-美国华源食品集团 + ${post.title}`"
					:src="post.pic.data ? post.pic.data.attributes.url : ''">
			</div>
			<div class="content" v-html="post.content">

			</div>
		</div>
	</div>
</template>

<script>
import qs from 'qs';
export default {
	name: "newsDetail",
	props: ['nid'],
	data() {
		return {
			post: {},
			// path: 'https://ocmfoods.com' + this.$route.fullPath,
			mediaList: [
				{
					img: require('@/assets/images/media/Facebook.png'),
					url: 'https://www.facebook.com/sharer/sharer.php?u=',
					txt: 'Share on FaceBook'
				},
				{
					img: require('@/assets/images/media/Instagram.png'),
					url: 'https://www.facebook.com/sharer/sharer.php?u=',
					txt: 'Share on FaceBook'
				},
				{
					img: require('@/assets/images/media/YouTube.png'),
					url: 'https://www.facebook.com/sharer/sharer.php?u=',
					txt: 'Share on FaceBook'
				},
				{
					img: require('@/assets/images/media/Twitter.png'),
					url: 'https://www.facebook.com/sharer/sharer.php?u=',
					txt: 'Share on FaceBook'
				},
				{
					img: require('@/assets/images/media/wechat.png'),
					url: 'https://www.facebook.com/sharer/sharer.php?u=',
					txt: 'Share on FaceBook'
				},
				{
					img: require('@/assets/images/media/xhs.png'),
					url: 'https://www.facebook.com/sharer/sharer.php?u=example.org',
					txt: 'Share on FaceBook'
				}
			]
		};
	},
	created() {
		this.getNewById();
	},
	mounted() {
		window.scrollTo(0, 0);
	},
	methods: {
		async getNewById() {
			const queryInfo = qs.stringify({
				locale: this.$i18n.locale,
				populate: 'deep',
			}, {
				encodeValuesOnly: true,
			});
			const {data: {data: {attributes: post}}} = await this.$http.get(`${this.$strapiUrl}/news/${this.nid}?${queryInfo}`);
			this.post = post;
		}
	},
	watch: {
		'$i18n.locale'(newValue) {
			if (this.post.localizations.data.length === 0) return false;
			this.$router.push({
				name: 'newsDetail',
				params: {nid: this.post.localizations.data[0].id}
			});
		}
	}
}
</script>

<style   lang="scss">
//news-detail
.news-detail {
	padding: 66px 0;
	.media {
		position: absolute;
		left: 130px;
		top: 30%;
		a {
			display: block;
			width: 36px;
			height: 36px;
			margin-bottom: 20px;
			img {
				display: block;
				width: 100%;
				height: 100%;
			}
		}
	}
	.title {
		text-align: center;
		margin-bottom: 40px;
		h2 {
			@extend .h2-28px;
		}
		h3 {
			@extend .h3-24px;
			margin: 16px 0 24px;
		}
		.date {
			@extend .regular-16px;
			opacity: 0.5;
		}
	}
	.pic {
		border-radius: 10px;
		overflow: hidden;
		margin-bottom: 40px;
		img {
			display: block;
			width: 100%;
		}
	}
	.content {
		h3 {
			@extend .h3-24px;
			margin-bottom: 24px;
		}
		p {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 16px;
			line-height: 150%;
			margin-bottom: 60px;
		}
	}
}
@media only screen and (max-width: 1199px) {
	.news-detail .media {
		left: 20px;
	}
}
@media only screen and (max-width: 959px) {
	.news-detail .media {
		display: flex;
		align-items: center;
		justify-content: center;
		position: static;
		margin: 20px 0;
		a {
			margin: 0 10px;
		}
	}
}
@media only screen and (max-width: 767px) {
	.news-detail {
		padding: 20px 0;
	}
	.page-back {
		margin-left: 20px;
	}
	.news-detail .title h3 {
		margin: 10px 0;
	}
	.news-detail .content h3 {
		font-size: 16px;
		line-height: 24px;
		margin-bottom: 10px;
	}
	.news-detail .content p {
		font-size: 14px;
		line-height: 21px;
		margin-bottom: 20px;
	}
}
</style>
